import { IPatient, IStandardCareProposal, Therapy } from '@alberta/konexi-shared';
import { getTherapy } from '@alberta/konexi-shared';
import { IArticle } from '@alberta/konexi-shared/dist/product/article';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { CrossTherapyArticleLineViewModel } from 'src/app/business/cross-therapy/cross-therapy-article-line-view-model';
import { IntegratedCareViewModel } from 'src/app/business/integrated-care/integratedcare-view-model';
import { ArticleDB } from 'src/app/common/repository/databases';
import { StandardCareProposalService } from 'src/app/shared/services/standard-care-proposal.service';
import { TherapyService } from 'src/app/shared/services/tenant-config/therapy.service';

import { ArticleDto } from './../../../../../../models/article/article-dto.model';
import { SelectionItem } from './../../../../../../models/selectionItem';
import { UserDto } from './../../../../../../models/user-management/user-dto.model';
import { ProductGroupTreeService } from './../../../../../../services/product-group/product-group-tree.service';
import { QueryService } from './../../../../../../services/query/query.service';
import { getCrossTherapyArticleForm } from './add-cross-therapy-article-form-builder';

@Component({
  selector: 'itl-add-cross-therapy-article',
  templateUrl: './add-cross-therapy-article.component.html',
  providers: [ProductGroupTreeService],
})
export class AddCrossTherapyArticleComponent implements OnInit {
  @Input() public articleFromDocument = false;

  public integratedCareViewModel: IntegratedCareViewModel;
  public therapyIcon: string;
  public therapyId: number;
  public therapyTypeId: number;
  public articleId: string;
  public showArticleSearch = false;
  public standardCareProposal: IStandardCareProposal;
  public restriction: any;
  public newArticleLine: CrossTherapyArticleLineViewModel;
  public showArticleData = false;
  public patient: IPatient;
  public disabled = false;
  public user: UserDto;
  public showScanButtons: boolean;
  public showStorageLocation = false;
  public showIdentificationNumbers = false;
  public articleRequiresIdentificationNumbers = false;

  public form: UntypedFormGroup;
  public therapySelectionItems: SelectionItem[] = [];
  public therapyTypeSelectionItems: SelectionItem[] = [];
  public therapyIdControl: AbstractControl;
  public therapyTypeIdControl: AbstractControl;

  constructor(
    private _therapyService: TherapyService,
    private _standardCareProposalService: StandardCareProposalService,
    private _modalController: ModalController,
    private _queryService: QueryService,
    private _formBuilder: FormBuilder
  ) {}

  async ngOnInit() {
    this.therapySelectionItems = await this._therapyService.getTherapySelectionItems();
    this.therapySelectionItems = this.therapySelectionItems.filter(item => item.id !== Therapy.NN);
    if (this.therapyId && this.therapyTypeId) {
      await this.therapyChanged();
      await this.therapyTypeChanged();
    }
  }

  public async therapyChanged() {
    if (this.therapyId) {
      const therapyItem = getTherapy(this.therapyId);
      this.therapyIcon = therapyItem.iconName;
      this.therapyTypeSelectionItems = await this._therapyService.getTherapyTypSelectionItems(this.therapyId);
    }
  }

  public async therapyTypeChanged() {
    if (this.therapyId && this.therapyTypeId) {
      await this._standardCareProposalService
        .loadStandardCareProposals(this.therapyId, this.therapyTypeId)
        .then(standardCareProposals => (this.standardCareProposal = standardCareProposals[0]));
      if (this.standardCareProposal) {
        const productGroups = this.standardCareProposal.sortedProductGroupsWithMaxAmount;
        const productGroupIds = [];
        productGroups.forEach(productGroup => productGroupIds.push(productGroup.productGroupId));
        if (productGroupIds) {
          this.restriction = (item: ArticleDto) => !productGroupIds.includes(item.productGroupId);
          this.showArticleSearch = true;
        }
      }
    }
  }

  public async enhanceArticle(articleId: string) {
    if (articleId) {
      this.newArticleLine = new CrossTherapyArticleLineViewModel();
      const newArticle = await this._queryService.get<IArticle>(this.articleId, ArticleDB);
      if (!newArticle) {
        return;
      }
      this.newArticleLine.initialize(newArticle);
      this.newArticleLine.quantity = 0;
      this.newArticleLine.therapyId = this.therapyId;
      this.newArticleLine.therapyTypeId = this.therapyTypeId;
      if (this.user) {
        this.newArticleLine.storageLocation = this.user.storageLocation;
      }

      const requiresBatchnumber = newArticle.requiresBatchnumber;
      const requiresSerialnumber = newArticle.requiresSerialnumber;
      if (requiresBatchnumber || requiresSerialnumber) {
        this.articleRequiresIdentificationNumbers = true;
      } else {
        this.articleRequiresIdentificationNumbers = false;
      }
      this.form = getCrossTherapyArticleForm(
        this.newArticleLine,
        this._formBuilder,
        requiresSerialnumber,
        requiresBatchnumber,
        this.showIdentificationNumbers
      );
      this.showArticleData = true;
    } else {
      this.showArticleData = false;
    }
  }

  public articleLineChanged(articleLine: CrossTherapyArticleLineViewModel) {
    this.newArticleLine = articleLine;
  }

  public async cancel(): Promise<void> {
    await this._modalController.dismiss().catch(error => console.log(error));
  }
  public async save(): Promise<void> {
    if (this.newArticleLine) {
      await this._modalController.dismiss(this.newArticleLine).catch(error => console.log(error));
    }
  }

  public updateFormControls() {
    this.form.controls.quantity.setValue(this.newArticleLine.quantity);
    this.form.controls.serialNumber.setValue(this.newArticleLine.serialNumber);
    this.form.controls.batchNumber.setValue(this.newArticleLine.batchNumber);
    this.form.controls.storageLocation.setValue(this.newArticleLine.storageLocation);
    this.form.controls.operatingHours.setValue(this.newArticleLine.operatingHours);
  }
}
